import { createFeatureSelector, createSelector } from '@ngrx/store';
import { WalletState, WalletData, FacturationData } from './wallet.reducer';

export const selectWalletState = createFeatureSelector<WalletState>('wallet');

// Base selectors
export const selectWalletsMap = createSelector(selectWalletState, (state) => state.walletsMap);

export const selectFacturationsMap = createSelector(selectWalletState, (state) => state.facturationsMap);

export const selectCurrentWallet = createSelector(selectWalletState, (state) => state.currentWallet);

export const selectCurrentFacturation = createSelector(selectWalletState, (state) => state.currentFacturation);

export const selectWalletLoading = createSelector(selectWalletState, (state) => state.loading);

export const selectWalletError = createSelector(selectWalletState, (state) => state.error);

// Get all wallets as array
export const selectAllWallets = createSelector(selectWalletsMap, (walletsMap) => Object.values(walletsMap));

// Get all facturations as array
export const selectAllFacturations = createSelector(selectFacturationsMap, (facturationsMap) => Object.values(facturationsMap));

// Get wallet by clientId and grandCompteId
export const selectWalletByClientAndGrandCompte = (clientId: string, grandCompteId: number) =>
    createSelector(selectWalletsMap, (walletsMap) => {
        const key = `${grandCompteId}_${clientId}`;
        return walletsMap[key] || null;
    });

// Get facturation by clientId and grandCompteId
export const selectFacturationByClientAndGrandCompte = (clientId: string, grandCompteId: number) =>
    createSelector(selectFacturationsMap, (facturationsMap) => {
        const key = `${grandCompteId}_${clientId}`;
        return facturationsMap[key] || null;
    });

// Get wallets for specific grand compte
export const selectWalletsByGrandCompte = (grandCompteId: number) =>
    createSelector(selectAllWallets, (wallets) => wallets.filter((w) => w.grandCompteId === grandCompteId));

// Get facturations for specific grand compte
export const selectFacturationsByGrandCompte = (grandCompteId: number) =>
    createSelector(selectAllFacturations, (facturations) => facturations.filter((f) => f.grandCompteId === grandCompteId));

// Convert to Map for compatibility with existing code
export const selectWalletsAsMap = createSelector(selectWalletsMap, (walletsMap) => {
    const map = new Map<string, WalletData>();
    Object.entries(walletsMap).forEach(([key, value]) => {
        map.set(key, value);
    });
    return map;
});

export const selectFacturationsAsMap = createSelector(selectFacturationsMap, (facturationsMap) => {
    const map = new Map<string, FacturationData>();
    Object.entries(facturationsMap).forEach(([key, value]) => {
        map.set(key, value);
    });
    return map;
});
